export const environment = {
  production: false,

  clientName: 'CAFARCOL - AGP',
  apiGatewayFront: 'https://proveedoresback.vivell.co/',
  apiGatewayBackOffice: 'https://proveedoresback.vivell.co/',
  apiUrl: 'https://proveedoresback.vivell.co/',
  urlPath: 'https://proveedoresback.vivell.co/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  enableDebug: false,
  // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
  // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX

  siteKeyCaptcha: '6LdeTtYmAAAAAH-uyD-5OLYYHogel9esyduM_S3e',

  googleAnalyticsCode: 'UA-140785247-1',
};